import React from 'react';

var Verified = (function (_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#7A34FF' : _ref$color,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '24' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '24' : _ref$height;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.411 2.08c.195.051.382.129.557.23L12 3.483l2.032-1.173a2.308 2.308 0 013.383 1.401l.607 2.267 2.267.607a2.308 2.308 0 011.401 3.383L20.517 12l1.173 2.032a2.308 2.308 0 01-1.401 3.383l-2.267.607-.607 2.267a2.308 2.308 0 01-3.383 1.401L12 20.517 9.968 21.69a2.308 2.308 0 01-3.383-1.401l-.607-2.267-2.267-.607a2.308 2.308 0 01-1.401-3.383L3.483 12 2.31 9.968A2.308 2.308 0 013.71 6.585l2.267-.607.607-2.267A2.308 2.308 0 019.41 2.08zm7.222 6.218a.989.989 0 00-1.406-.01l-4.89 4.89-1.88-1.873a1.002 1.002 0 00-1.414-.002.995.995 0 000 1.41l2.589 2.59a.996.996 0 001.412-.001l5.588-5.588c.385-.386.39-1.024 0-1.416z",
    fill: color,
    fillRule: "evenodd"
  }));
});

export { Verified as default };
//# sourceMappingURL=verified.js.map
